<template>
  <PageLayout class="add-Quality-Problem-fourth-steps-layout pa-6">
    <div style="display: flex; flex-direction: row; align-items: center">
      <m-page-header :title="$t(`apply.title.fileUpload`)">></m-page-header>
      <m-popover trigger="hover">
        <template #content>
          <div>
            {{ $t(`apply.title.upImgTip3`) }}
            <div class="pointDivStyles">
              <!-- <div class="pointStyles"></div> -->
              {{ $t(`apply.title.upImgTip4`) }}
            </div>
            <div class="pointDivStyles">
              <!-- <div class="pointStyles"></div> -->
              {{ $t(`apply.title.upImgTip5`) }}
            </div>
            <div class="pointDivStyles">
              <!-- <div class="pointStyles"></div> -->
              {{ $t(`apply.title.upImgTip6`) }}
            </div>
            <div class="pointDivStyles">
              <!-- <div class="pointStyles"></div> -->
              {{ $t(`apply.title.upImgTip7`) }}
            </div>
          </div>
        </template>
        <ExclamationCircleOutlined
          class="pl-2 ma-0"
          style="color: var(--m-primary-color)"
        />
      </m-popover>
    </div>

    <m-form ref="form">
      <div class="mt-4">
        <m-row :gutter="24">
          <div v-for="(item, index) in form.documentTypes" :key="index">
            <m-folding-panel
              :key="`upload-${index}`"
              enableCollapsed
              :active="true"
              :class="`rainbow__folding__panel rainbow__page${index % 4}`"
            >
              <template v-slot:header>
                <span
                  ><span
                    v-if="item?.requiredMultiple.includes('WEB')"
                    class="required-star"
                    >* </span
                  >{{ isZHHANT() ? item.nameCn : item.namePt }}</span
                >
              </template>
              <!-- <span
                ><span
                  v-if="item?.requiredMultiple.includes('WEB')"
                  class="required-star"
                  >*</span
                >{{ isZHHANT() ? item.nameCn : item.namePt }}</span
              > -->
              <div
                class="noStart"
                style="flex-direction: row; display: flex; align-items: center"
                v-if="item.mailing"
              >
                <span
                  v-if="item?.requiredMultiple.includes('WEB')"
                  class="required-star"
                  >*</span
                >
                <m-radio-group
                  class="input__box mt-6"
                  is-form-item
                  :value="item.mailingType"
                  :rules="[
                    {
                      required: item?.requiredMultiple.includes('WEB'),
                      message: $t('Common.message.selUpdateType'),
                    },
                  ]"
                  @click.native.stop
                >
                  <m-radio
                    v-for="updateTypeItem in updateTypeOptions"
                    :value="updateTypeItem.value"
                    :key="updateTypeItem.value"
                    @click.native.stop="
                      handleRadioClick(item, updateTypeItem.value, index)
                    "
                    >{{ updateTypeItem.label }}
                  </m-radio>
                </m-radio-group>
              </div>
              <div
                v-if="!item.mailing || item.mailingType === 'update2'"
                style="flex-direction: column"
                class="noStart"
              >
                <div
                  style="
                    flex-direction: row;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <m-upload
                    multiple
                    style="flex: 1"
                    isFormItem
                    :file-list="item?.fileList"
                    accept="image/png, image/jpeg, .pdf"
                    layout="vertical"
                    @change="(files) => handleUploadChange(files, item, index)"
                    @preview="handlePreview"
                    :rules="[
                      {
                        required: item?.requiredMultiple.includes('WEB'),
                        type: 'array',
                        min: 1,
                        message: $t('Common.message.imageTip'),
                      },
                    ]"
                  >
                    <m-button type="primary">
                      <m-icon type="upload" />{{
                        $t('apply.title.uploadFiles')
                      }}
                    </m-button>
                  </m-upload>
                  <span v-if="item?.fileList?.length > 0">
                    <a
                      class="icon__close mx-4"
                      @click.stop="onDeleteAllFile(item, index)"
                    >
                      <CloseOutlined
                        class="anticon anticon-close pa-0 ma-0"
                        style="font-size: 12px !important"
                      />
                    </a>
                  </span>
                </div>
                <div style="color: #acacac">
                  {{ $t(`apply.title.upImgTip1`) }}
                </div>
              </div>
            </m-folding-panel>
          </div>
        </m-row>
      </div>
    </m-form>
    <PdfViewr
      :visible="pdfVisible"
      :blobUrl="pdfBlobUrl"
      @close="handleClose"
    />
  </PageLayout>
</template>

<script>
import PageLayout from 'common/components/Layout/web/PageLayout.vue';
import { FileAPI, ApplyAPI } from '@/api';
import {
  CloseOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue';
import {
  convertToBlob,
  blobToFiles,
  viewImages,
} from 'govmo-common/src/utils/file';
import PdfViewr from '@/components/PdfViewr.vue';
import { isZHHANT } from 'govmo-common/src/utils/utils';
import { updateTypeOptions } from 'govmo-common/src/utils/options';

function debounce(func, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
export default {
  components: {
    PageLayout,
    CloseOutlined,
    PdfViewr,
    ExclamationCircleOutlined,
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      updateTypeOptions: updateTypeOptions(),
      form: {},
      fileList: [],
      pdfVisible: false,
      pdfBlobUrl: '',
    };
  },
  computed: {
    isFileMax() {
      const allFileSize = (
        this.fileList.reduce((pre, cru) => pre + cru.size, 0) /
        1024 /
        1024
      ).toFixed(2);
      return allFileSize >= 50;
    },
  },
  methods: {
    isZHHANT,
    onPrevious() {
      this.$emit('previous');
    },
    async onNext() {
      if (!(await this.$refs.form.validateFields())) return;
      let mailingUpdateBody = [];
      this.form.documentTypes.forEach((item) => {
        if (item.mailing && item.mailingType === 'update1') {
          mailingUpdateBody.push({
            typeIndex: item.index,
            applicationType: item.applicationType,
            companyType: this.form.companyType,
            applicationNo: this.form.applicationNo,
            mailing: item.mailingType === 'update1' ? true : false,
          });
        }
      });
      try {
        this.$showLoading();
        //邮寄上传
        if (mailingUpdateBody.length > 0) {
          await FileAPI.mailingUpload(mailingUpdateBody);
        }
        await ApplyAPI.validateDocuments(
          this.form.applicationNo,
          this.form.applicationType,
          this.form.companyType
        );
        this.$emit('next', this.form);
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    //預覽
    async handlePreview(file) {
      console.log('預覽', file);
      if (file.url && file.suffix !== 'pdf') {
        if (file.tempId && file.type === 'application/pdf') {
          const base64 = `data:${file.type};base64,${file.byte}`;
          // base64轉blob轉files
          const blob = convertToBlob(base64);
          let url = URL.createObjectURL(blob);
          this.pdfBlobUrl = url;
          this.pdfVisible = true;
          return;
        } else {
          viewImages([file.url]);
          return;
        }
      }
      try {
        this.$showLoading();
        let content = await FileAPI.getDocumentById(file.contentId);
        const mimeType = file.prefix.match(/^data:(.*?);/)[1];
        const base64 = `${file.prefix}${content}`;
        // base64轉blob轉files
        const blob = convertToBlob(base64);
        let url = URL.createObjectURL(blob);
        const files = blobToFiles({
          blob,
          fileName: `${file.originalFileName}.${file.suffix}`,
          type: mimeType,
        });
        file.originFileObj = files;
        file.url = url;
        file.thumbUrl = base64;
        this.form.documentTypes.forEach((file) => {
          file.fileList.forEach((item) => {
            if (item.contentId === file.contentId) {
              item = file;
            }
          });
        });
        if (file.suffix === 'pdf') {
          this.pdfBlobUrl = url;
          this.pdfVisible = true;
        } else {
          viewImages([url]);
        }
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    //删除所有
    async onDeleteAllFile(items, index) {
      try {
        this.$showLoading();
        await FileAPI.deleteDocumentAll(this.form.applicationNo, items.index);
        let tempDocument = [...this.form.documentTypes];
        tempDocument[index].fileList = [];
        tempDocument[index].euids = [''];
        tempDocument[index].updateType = 'update1';
        this.$set(this.form, 'documentTypes', tempDocument);
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    //刪除单个
    async onDeleteFile(info, index) {
      console.log('刪除单个');
      try {
        this.$showLoading();
        await FileAPI.deleteDocument(info?.file.tempId);
        let tempDocument = [...this.form.documentTypes];
        tempDocument[index].fileList = info.fileList;
        this.$set(this.form, 'documentTypes', tempDocument);
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    handleRadioClick: debounce(async function (item, newValue, index) {
      try {
        if (item.mailingType === newValue) return;
        // 先执行删除操作
        await this.onDeleteAllFile(item, index);
        // 只有删除成功后才会更新值
        let tempDocument = [...this.form.documentTypes];
        tempDocument[index].mailingType = newValue;
        this.$set(this.form, 'documentTypes', tempDocument);
        // 强制重新验证表单
        this.$nextTick(() => {
          this.$refs.form.validateFields();
        });
      } catch (error) {
        console.log(error);
      }
    }, 500),
    handleUploadChange: debounce(async function (info, items, index) {
      console.log('===info', info);

      //刪除单个
      if (info.file.tempId) {
        this.onDeleteFile(info, index);
        return;
      }
      //上傳
      if (info?.file.size === 0 || info?.file.size / 1024 / 1024 > 5) {
        this.$error(this.$t('Common.message.fileRequire1'));
        return;
      } else if (
        info?.file?.type !== 'image/jpeg' &&
        info?.file?.type !== 'image/png' &&
        info?.file?.type !== 'application/pdf'
      ) {
        this.$error(this.$t('Common.enum.fileUploadErrorTip.-1'));
        return;
      } else {
        try {
          this.$showLoading();
          // 1. 获取旧文件列表（已存在的文件）
          const oldFileList = items.fileList || [];
          // 2. 找出本次新增的文件（对比新旧列表）
          const newFiles = info.fileList.filter((newFile) => {
            return !oldFileList.some(
              (oldFile) => oldFile.uid === newFile.uid // 或对比其他唯一标识（如 name + size）
            );
          });
          let formData = new FormData();

          newFiles.forEach((file) => {
            let fileBlob = new Blob([file.originFileObj], {
              type: file.originFileObj && file.originFileObj.type,
            });
            formData.append(
              'files',
              fileBlob,
              file.originFileObj && file.originFileObj.name
            );
          });
          formData.append('typeIndex', items.index);
          formData.append('applicationType', this.form.applicationType);
          formData.append('companyType', this.form.companyType);
          formData.append('applicationNo', this.form.applicationNo);

          let fileData = await FileAPI.uploadFile(formData);
          fileData.forEach((file) => {
            info.fileList.forEach((listFile) => {
              if (file.name === listFile.name) {
                listFile.tempId = file.tempId;
                listFile.byte = file.base64;
              }
            });
          });

          let tempDocument = [...this.form.documentTypes];
          tempDocument[index].fileList = info.fileList;
          tempDocument[index].updateType = 'update1';
          this.$set(this.form, 'documentTypes', tempDocument);
        } catch (error) {
          this.$error(error);
        } finally {
          this.$hideLoading();
        }
      }
    }, 500),
    handleClose() {
      this.pdfVisible = false;
      // 清理blob URL
      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
      }
    },
    async showTip(items, index) {
      console.log('====showTip', items);
      if (items.euids?.length > 0 && items.euids[0].length > 0) {
        try {
          await this.$confirm({
            message: this.$t('apply.message.deleteEuidTip'),
          });
          console.log('用户点击了确认');
          this.onDeleteAllFile(items, index);
          this.$refs[`uploadRef${index}`][0].$el
            .querySelector('input[type="file"]')
            .click();
        } catch (error) {
          console.log('用户点击了取消');
        } finally {
          this.$hideLoading();
        }
      } else {
        this.$refs[`uploadRef${index}`][0].$el
          .querySelector('input[type="file"]')
          .click();
      }
    },
  },
  beforeDestroy() {
    this.handleClose();
  },
  async created() {
    this.form = {
      ...this.formData,
    };
    console.log('====3', this.form);
  },
};
</script>

<style lang="scss" scoped>
// .add-Quality-Problem-fourth-steps-layout {
//   height: calc(100vh - 330px);
//   overflow-y: auto;
// }

:deep(.ant-upload-list-picture .ant-upload-list-item) {
  margin: 8px 8px 0px;
  border-radius: 4px;
  float: left;
  width: 200px;
  background-color: rgba(204, 204, 204, 0.15);
  cursor: pointer;
}
:deep(.ant-upload-list-picture .ant-upload-list-item) {
  background-color: rgba(204, 204, 204, 0.15) !important;
}
:deep(.ant-upload-list-picture .ant-upload-list-item-info > span) {
  background-color: unset;
}
.icon__close {
  width: 22px;
  height: 22px;
  svg {
    fill: #000000;
  }
}

.noStart :deep(.m-form-item-wrapper.require .label-wrapper::before) {
  content: '';
}
.noLabel
  :deep(
    .m-form-item-wrapper .label-wrapper,
    .m-form-item-wrapper .label-placeholder
  ) {
  width: 0;
}
.field
  :deep(
    .m-form-item-wrapper .field-wrapper,
    .m-form-item-wrapper .field-placeholder
  ) {
  width: 100%;
}
.requiredTip :deep(.m-form-item-wrapper .m-form-item-secondary) {
  display: block;
  margin-left: 10px;
  align-items: flex-start;
}
.euid-input-wrapper {
  display: flex;
  // align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  margin-top: 8px;
}

.required-star {
  color: red;
}

:deep(.input__box) {
  .label-wrapper {
    width: 0%;
  }
  .label-placeholder {
    width: 0%;
  }
  .field-wrapper {
    width: 100%;
  }
}
:deep(
    .m-form-item-wrapper.vertical .label-wrapper,
    .m-form-item-wrapper.vertical .label-placeholder,
    .m-form-item-wrapper.vertical .field-wrapper,
    .m-form-item-wrapper.vertical .field-placeholder
  ) {
  background-color: red;
  height: 0px;
}
</style>
